"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const sidebar_style_1 = __importDefault(require("../sidebar.style"));
const material_1 = require("@mui/material");
const button_1 = require("components/atoms/button");
const up_icon_svg_1 = __importDefault(require("assets/img/up-icon.svg"));
const down_icon_svg_1 = __importDefault(require("assets/img/down-icon.svg"));
const submenu_1 = __importDefault(require("./submenu"));
const svg_1 = require("components/atoms/svg");
const constants_1 = require("utils/constants");
const authorization_1 = require("utils/authorization");
const MenuItem = ({ menu, item, status, userData, onClick, onClickSubMenu, }) => {
    const conditionShowIcon = item.subMenu.length > 0 && item.menu !== 'Hopper' && status === 'expand';
    const colorMenu = item.selected ? constants_1.color.sidebarTitleDark : constants_1.color.white;
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ onClick: () => onClick(), style: sidebar_style_1.default.menuItem(item.selected) }, { children: [(0, jsx_runtime_1.jsx)(IconRender, { fill: colorMenu, menu: menu }), item.title && status === 'expand' && ((0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ style: sidebar_style_1.default.menuTitle(item.selected), variant: 'caption' }, { children: item.title }))), conditionShowIcon && ((0, jsx_runtime_1.jsx)(button_1.Icon, { src: item.selected ? up_icon_svg_1.default : down_icon_svg_1.default, style: sidebar_style_1.default.keyboardIcon }))] })), item.selected && conditionShowIcon && (item.subMenu.map((subMenu, index) => {
                const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, menu, subMenu.subMenuName);
                return (isAuthorized.view || isAuthorized.change) && ((0, jsx_runtime_1.jsx)(submenu_1.default, { onClick: (subMenu) => onClickSubMenu(subMenu, item), subMenuItem: subMenu }, index));
            }))] }));
};
exports.default = MenuItem;
const IconRender = ({ menu, fill }) => {
    switch (menu) {
        case 'Dashboard': {
            return (0, jsx_runtime_1.jsx)(svg_1.DashboardIcon, { color: fill });
        }
        case 'Silo': {
            return (0, jsx_runtime_1.jsx)(svg_1.SiloIcon, { color: fill });
        }
        case 'CCTV Center': {
            return (0, jsx_runtime_1.jsx)(svg_1.CCTVIcon, { color: fill });
        }
        case 'Hopper': {
            return (0, jsx_runtime_1.jsx)(svg_1.HopperIcon, { color: fill });
        }
        case 'BG. Loading Transshipment': {
            return (0, jsx_runtime_1.jsx)(svg_1.BGLoadingAndTranshipmentIcon, { color: fill });
        }
        case 'Report': {
            return (0, jsx_runtime_1.jsx)(svg_1.ReportIcon, { color: fill });
        }
        case 'Stockpile': {
            return (0, jsx_runtime_1.jsx)(svg_1.StockpileIcon, { color: fill });
        }
        case 'Master Data': {
            return (0, jsx_runtime_1.jsx)(svg_1.MasterDataIcon, { color: fill });
        }
        case 'User Access': {
            return (0, jsx_runtime_1.jsx)(svg_1.UserAccessIcon, { color: fill });
        }
        case 'Configuration': {
            return (0, jsx_runtime_1.jsx)(svg_1.ConfigIcon, { color: fill });
        }
        case 'Daily Summary': {
            return (0, jsx_runtime_1.jsx)(svg_1.DailySummaryIcon, { color: fill });
        }
        case 'Adjustment': {
            return (0, jsx_runtime_1.jsx)(svg_1.AdjustmentIcon, { color: fill });
        }
        case 'Coal Chain Simulation': {
            return (0, jsx_runtime_1.jsx)(svg_1.Simulation, { color: fill });
        }
        default: {
            return (0, jsx_runtime_1.jsx)(svg_1.MasterDataIcon, { color: fill });
        }
    }
};
